/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { mobileTheme, webTheme } from '@farmlands/mui-theme';

import { isPlatformMobile } from '../util/platform';

export const farmlandsMuiTheme = isPlatformMobile()
  ? mobileTheme
  : webTheme;
